import { Component, Inject, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { IAcaoPlanoAcaoModel, IPlanoAcaoModel } from "../../../models/plano-acao-model";
import { PlanoAcaoService } from "../../../services/plano-acao.service";
import { PlanoAcaoFormPreencherAcaoComponent } from "./plano-acao-form-preencher-acao/plano-acao-form-preencher-acao.component";
import { PlanoAcaoFormHistoricoAcaoComponent } from "./plano-acao-form-historico-acao/plano-acao-form-historico-acao.component";

@Component({
  selector: 'app-plano-acao-form-preencher',
  templateUrl: './plano-acao-form-preencher.component.html',
  styleUrls: ['./plano-acao-form-preencher.component.scss']
})
export class PlanoAcaoFormPreencherComponent implements OnInit, AfterViewInit {

  public id: number = 0;
  public dataSource = new MatTableDataSource<IAcaoPlanoAcaoModel>([]);
  public visualizar: boolean = false;
  public titulo: string = "";

  public model: IPlanoAcaoModel = {} as IPlanoAcaoModel;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public matDialog: MatDialog,
    public servicePlanoAcao: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoFormPreencherComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.id = data?.id || 0;
    this.visualizar = data?.visualizar || false;
    this.titulo = data?.titulo || '';
  }

  ngOnInit(): void {
    this.buscar();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "identificador": return item?.identificador;
      case "titulo": return item?.titulo;
      case "prazo": return item?.prazo;
      case "responsavel": return item?.responsavelNome;
      case "status": return item?.status;
      default: return item[property];
    }
  };

  public buscar() {

    this.servicePlanoAcao
      .obterPorId(this.id)
      .then((res) => {

        if (res.sucesso) {

          this.model = res.dados;
          this.dataSource.data = this.model.acoes || [];

          this.cdr.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public modalAcao(titulo: string, visualizar: boolean, element?: IAcaoPlanoAcaoModel) {

    // Demanda 68742 linha 41 (crit 14): ação avaliada como Atendida Parcialmente(10)/Não Atendida(11)
    // pergunta se deseja iniciar nova tentativa; "Sim" cria novo ciclo e muda o status para "A ser Realizada".
    const precisaNovaTentativa = !visualizar && element &&
      (element.status?.codigo === 10 || element.status?.codigo === 11);

    if (precisaNovaTentativa) {
      Swal.fire({
        title: "Nova tentativa de implementação",
        text: "Deseja iniciar uma nova tentativa de implementação dessa ação?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (!res.isConfirmed) return;

        this.servicePlanoAcao.iniciarNovaTentativa(element.id).then((r) => {
          if (!r.sucesso) {
            Swal.fire({
              toast: true, position: "top-end", icon: "warning",
              text: r.mensagem?.descricao, showConfirmButton: false, timer: 5000, timerProgressBar: true,
            });
            return;
          }
          this.abrirModalAcao(titulo, visualizar, element);
        });
      });
      return;
    }

    this.abrirModalAcao(titulo, visualizar, element);
  }

  private abrirModalAcao(titulo: string, visualizar: boolean, element?: IAcaoPlanoAcaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-preencher";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "180vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      id: element?.id,
      planoAcaoId: this.model.id,
      unidadeGestoraId: this.model.unidadeGestoraId,
      osaExecucaoId: this.model.osaExecucaoId,
      element
    };

    const modal = this.matDialog.open(PlanoAcaoFormPreencherAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }

  // Demanda 68742 linha 39 (crit 6): planos EmExecucao(4)/NaoImplementado(7)/ImplementadoParcialmente(8),
  // ações AserRealizada(6)/EmExecução(7)/AserEnviada(14)/AtendidaParcialmente(10)/NaoAtendida(11); bloqueia FinMan/FinAut/Cancelado(6).
  podePreencher(acao: IAcaoPlanoAcaoModel): boolean
  {
    if (this.model?.monitoramentoFinMan === true || this.model?.monitoramentoFinAut === true) return false;
    if (this.model?.status?.codigo === 6) return false;
    const planoOk = this.model?.status?.codigo === 4 || this.model?.status?.codigo === 7 || this.model?.status?.codigo === 8;
    const acaoOk = acao?.status?.codigo === 6 || acao?.status?.codigo === 7 || acao?.status?.codigo === 14 || acao?.status?.codigo === 10 || acao?.status?.codigo === 11;
    return planoOk && acaoOk;
  }


  public modalHistorico(element?: IAcaoPlanoAcaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-historico";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;

    dialogConfig.data = { id: element?.id, identificador: element?.identificador, idFuncionalidade: 41 };

    const modal = this.matDialog.open(PlanoAcaoFormHistoricoAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }  

}
